export const useMobileApp = () => {
	const isMobileApp = typeof navigator !== 'undefined' && navigator.userAgent.includes('THDMXAPP');

	return { isMobileApp };
};
